import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_humanize_time = _resolveComponent("humanize-time")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_message = _resolveComponent("message")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createBlock(_component_q_table, {
    columns: _ctx.columns,
    rows: _ctx.userClients,
    selection: "multiple",
    selected: _ctx.selected,
    "selected-rows-label": _ctx.selectedLabel,
    loading: _ctx.isLoading,
    "rows-per-page-options": [0],
    flat: "",
    "onUpdate:selected": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:selected', $event)))
  }, {
    "body-cell-assignedAt": _withCtx((props) => [
      _createVNode(_component_q_td, { props: props }, {
        default: _withCtx(() => [
          _createVNode(_component_humanize_time, {
            time: props.value
          }, null, 8, ["time"])
        ]),
        _: 2
      }, 1032, ["props"])
    ]),
    "no-data": _withCtx(() => [
      _withDirectives(_createVNode(_component_message, { class: "full-width" }, {
        default: _withCtx(() => [
          _createTextVNode(" User is not assigned to any clients. ")
        ]),
        _: 1
      }, 512), [
        [_vShow, !_ctx.isLoading]
      ])
    ]),
    _: 1
  }, 8, ["columns", "rows", "selected", "selected-rows-label", "loading"]))
}